var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "damage-summary" } },
    [
      _vm.isLoaderActive ? _c("ma-loader") : _vm._e(),
      _c(
        "div",
        { staticClass: "header-section" },
        [
          _c("p", { staticClass: "headline-large black" }, [
            _vm._v(_vm._s(_vm.$t("warrantySticky.damageSummary.title")))
          ]),
          _vm.stateUserIsMixEnable
            ? _c("ma-toggle-button", {
                attrs: { options: _vm.mixCompensationButtonOptions },
                on: { selected: _vm.handleMixButton }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.stateWarrantyReport && _vm.warrantiesList
        ? _c("div", { staticClass: "table-section" }, [
            _c(
              "div",
              {
                staticClass: "table-content",
                class: { "redux-mode": _vm.stateUserIsReduxMode }
              },
              [
                _c("div", { staticClass: "bg-blueDarkHover d-flex" }, [
                  _c("div", { staticClass: "tab-damages b-left" }, [
                    !_vm.stateUserIsReduxMode
                      ? _c(
                          "p",
                          { staticClass: "text-medium text-left white" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "warrantySticky.damageSummary.tableHead.damages"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "tab-separator" }),
                  _c("div", { staticClass: "tab-gag" }, [
                    _c("p", { staticClass: "text-medium text-left white" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "warrantySticky.damageSummary.tableHead.greAGre"
                          )
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "tab-separator" }),
                  _c("div", { staticClass: "tab-ren" }, [
                    _c("p", { staticClass: "text-medium text-left white" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "warrantySticky.damageSummary.tableHead.reparationNetwork"
                          )
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "tab-separator" }),
                  _c("div", { staticClass: "tab-asp b-right" }, [
                    _c("p", { staticClass: "text-medium text-left white" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "warrantySticky.damageSummary.tableHead.reparationExcept"
                          )
                        )
                      )
                    ])
                  ])
                ]),
                _vm._l(_vm.warrantiesList, function(groupValue, groupKey) {
                  return !_vm.stateUserIsReduxMode && groupKey
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "tab-group-header bg-blueDark d-flex"
                          },
                          [
                            _c("div", { staticClass: "tab-damages b-left" }, [
                              _c("p", { staticClass: "text-medium white" }, [
                                _vm._v(_vm._s(groupValue.literal))
                              ])
                            ]),
                            _c("div", { staticClass: "tab-separator" }),
                            _c("div", { staticClass: "tab-gag table-cell" }, [
                              !_vm.stateUserIsReduxMode
                                ? _c("div", [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium white" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantySticky.damageSummary.tableMain.manpowerHours"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              !_vm.stateUserIsReduxMode
                                ? _c("div", { staticClass: "b-left" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-medium white power-cost"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "warrantySticky.damageSummary.tableMain.manpowerCost"
                                              )
                                            )
                                          )
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "edit-cost",
                                            on: { click: _vm.showManpower }
                                          },
                                          [
                                            _c("svgicon", {
                                              staticClass:
                                                "svg-icon-action-white",
                                              attrs: {
                                                icon: "edit",
                                                height: "18",
                                                color: "white"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              !_vm.stateUserIsReduxMode
                                ? _c("div", { staticClass: "b-left" }, [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium white" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantySticky.damageSummary.tableMain.materialCost"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  class: { "b-left": !_vm.stateUserIsReduxMode }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-medium white" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "warrantySticky.damageSummary.tableMain.totalCost"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "tab-separator" }),
                            _c("div", { staticClass: "tab-ren table-cell" }, [
                              !_vm.stateUserIsReduxMode
                                ? _c("div", [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium white" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantySticky.damageSummary.tableMain.priceWithoutTaxes"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  class: { "b-left": !_vm.stateUserIsReduxMode }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-medium white" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "warrantySticky.damageSummary.tableMain.priceWithTaxes"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "tab-separator" }),
                            _c("div", { staticClass: "tab-asp table-cell" }, [
                              !_vm.stateUserIsReduxMode
                                ? _c("div", [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium white" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantySticky.damageSummary.tableMain.priceWithoutTaxes"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  class: { "b-left": !_vm.stateUserIsReduxMode }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-medium white" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "warrantySticky.damageSummary.tableMain.priceWithTaxes"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "tab-container tab-group-totals d-flex"
                          },
                          [
                            _c("div", { staticClass: "tab-damages b-left" }, [
                              _c("p", [_vm._v(_vm._s(_vm.$t("common.total")))])
                            ]),
                            _c("div", { staticClass: "tab-separator" }),
                            _c("div", { staticClass: "tab-gag table-cell" }, [
                              !_vm.stateUserIsReduxMode
                                ? _c("div", [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium black" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            groupValue.totals.manpower_hours
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              !_vm.stateUserIsReduxMode
                                ? _c("div", { staticClass: "b-left" }, [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium black" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            groupValue.totals
                                              .total_manpower_cost
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              !_vm.stateUserIsReduxMode
                                ? _c("div", { staticClass: "b-left" }, [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium black" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            groupValue.totals
                                              .total_material_cost
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  class: { "b-left": !_vm.stateUserIsReduxMode }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-medium black" },
                                    [
                                      _vm._v(
                                        _vm._s(groupValue.totals.total_gag_cost)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "tab-separator" }),
                            _c("div", { staticClass: "tab-ren table-cell" }, [
                              !_vm.stateUserIsReduxMode
                                ? _c("div", [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium black" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            groupValue.totals
                                              .authorized_network_repair_without_taxes
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  class: { "b-left": !_vm.stateUserIsReduxMode }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-medium black" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          groupValue.totals
                                            .authorized_network_repair
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "tab-separator" }),
                            _c("div", { staticClass: "tab-asp table-cell" }, [
                              !_vm.stateUserIsReduxMode
                                ? _c("div", [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium black" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            groupValue.totals
                                              .artessian_repair_without_taxes
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  class: { "b-left": !_vm.stateUserIsReduxMode }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-medium black" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          groupValue.totals.artessian_repair
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._l(_vm.getDamagesList(groupValue), function(
                          damage
                        ) {
                          return _c(
                            "div",
                            {
                              staticClass: "tab-container tab-group-list d-flex"
                            },
                            [
                              _c("div", { staticClass: "tab-damages b-left" }, [
                                damage.damage.description
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "text-medium black",
                                        class: {
                                          "damage-name-mix": _vm.isMixAvailable
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getDamageDescription(damage)
                                          )
                                        )
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass: "text-medium black",
                                        class: {
                                          "damage-name-mix": _vm.isMixAvailable
                                        }
                                      },
                                      [_vm._v(_vm._s(damage.damage))]
                                    ),
                                _c(
                                  "div",
                                  { staticClass: "damage-name-actions" },
                                  [
                                    damage.images
                                      ? _c(
                                          "span",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.preparePhotosModal(
                                                  damage
                                                )
                                              }
                                            }
                                          },
                                          [
                                            damage.images.length > 0
                                              ? _c("svgicon", {
                                                  attrs: {
                                                    icon: "ico-photos",
                                                    height: "16",
                                                    color: "#A7AEB6"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    damage.can_delete && _vm.isMixAvailable
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "right",
                                            attrs: {
                                              "qa-deleteReportItem-button": ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleRemoveDamage(
                                                  damage.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("svgicon", {
                                              staticClass:
                                                "svg-icon svg-icon-action",
                                              attrs: {
                                                icon: "trash",
                                                height: "18"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "tab-separator" }),
                              _c("div", { staticClass: "tab-gag table-cell" }, [
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium black" },
                                        [
                                          _vm._v(
                                            _vm._s(damage.gag.manpower_hours)
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", { staticClass: "b-left" }, [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium black" },
                                        [
                                          _vm._v(
                                            _vm._s(damage.gag.manpower_cost)
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", { staticClass: "b-left" }, [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium black" },
                                        [
                                          _vm._v(
                                            _vm._s(damage.gag.material_cost)
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "total-value",
                                    class: {
                                      "b-left": !_vm.stateUserIsReduxMode
                                    }
                                  },
                                  [
                                    _c(
                                      "ma-mix-clickable-cell",
                                      {
                                        attrs: {
                                          damageId: damage.id,
                                          isMixEnabled: !!(
                                            _vm.isMixAvailable && damage.id
                                          ),
                                          type: _vm.gagKey,
                                          repTypeSelected: damage.rep_type,
                                          selected:
                                            damage.rep_type === _vm.gagKey
                                        },
                                        on: {
                                          selected: function($event) {
                                            return _vm.handleOnSelectTotal(
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "cellContent" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "text-medium black"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(damage.gag.gag_cost)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c("div", { staticClass: "tab-separator" }),
                              _c("div", { staticClass: "tab-ren table-cell" }, [
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium black" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              damage.authorized_network_repair
                                                .market_price_without_taxes
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "total-value",
                                    class: {
                                      "b-left": !_vm.stateUserIsReduxMode
                                    }
                                  },
                                  [
                                    _c(
                                      "ma-mix-clickable-cell",
                                      {
                                        attrs: {
                                          damageId: damage.id,
                                          isMixEnabled: !!(
                                            _vm.isMixAvailable && damage.id
                                          ),
                                          type: _vm.networkRepairKey,
                                          repTypeSelected: damage.rep_type,
                                          selected:
                                            damage.rep_type ===
                                            _vm.networkRepairKey
                                        },
                                        on: {
                                          selected: function($event) {
                                            return _vm.handleOnSelectTotal(
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "cellContent" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "text-medium black"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    damage
                                                      .authorized_network_repair
                                                      .market_price_with_taxes
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c("div", { staticClass: "tab-separator" }),
                              _c("div", { staticClass: "tab-asp table-cell" }, [
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium black" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              damage.artessian_repair
                                                .market_price_without_taxes
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "total-value",
                                    class: {
                                      "b-left": !_vm.stateUserIsReduxMode
                                    }
                                  },
                                  [
                                    _c(
                                      "ma-mix-clickable-cell",
                                      {
                                        attrs: {
                                          damageId: damage.id,
                                          isMixEnabled: !!(
                                            _vm.isMixAvailable && damage.id
                                          ),
                                          type: _vm.artessianRepairKey,
                                          repTypeSelected: damage.rep_type,
                                          selected:
                                            damage.rep_type ===
                                            _vm.artessianRepairKey
                                        },
                                        on: {
                                          selected: function($event) {
                                            return _vm.handleOnSelectTotal(
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "cellContent" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "text-medium black"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    damage.artessian_repair
                                                      .market_price_with_taxes
                                                  )
                                                )
                                              ]
                                            ),
                                            !_vm.isMixAvailable
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "delete-damage"
                                                  },
                                                  [
                                                    damage.can_delete &&
                                                    !_vm.isMixAvailable
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass: "left",
                                                            attrs: {
                                                              "qa-deleteReportItem-button":
                                                                ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.handleRemoveDamage(
                                                                  damage.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("svgicon", {
                                                              staticClass:
                                                                "svg-icon svg-icon-action",
                                                              attrs: {
                                                                icon: "trash",
                                                                height: "18"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        })
                      ]
                    : _vm._e()
                }),
                _vm._l(_vm.reduxList, function(pieces, index) {
                  return index
                    ? _vm._l(pieces, function(damages, index) {
                        return _c("div", { staticClass: "tab-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tab-group-header bg-blueDark d-flex"
                            },
                            [
                              _c("div", { staticClass: "tab-damages b-left" }, [
                                _c("p", { staticClass: "text-medium white" }, [
                                  _vm._v(_vm._s(damages.name))
                                ])
                              ]),
                              _c("div", { staticClass: "tab-separator" }),
                              _c("div", { staticClass: "tab-gag table-cell" }, [
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium white" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "warrantySticky.damageSummary.tableMain.manpowerHours"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", { staticClass: "b-left" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-medium white power-cost"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "warrantySticky.damageSummary.tableMain.manpowerCost"
                                                )
                                              )
                                            )
                                          ]),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "edit-cost",
                                              on: { click: _vm.showManpower }
                                            },
                                            [
                                              _c("svgicon", {
                                                staticClass:
                                                  "svg-icon-action-white",
                                                attrs: {
                                                  icon: "edit",
                                                  height: "18",
                                                  color: "white"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", { staticClass: "b-left" }, [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium white" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "warrantySticky.damageSummary.tableMain.materialCost"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "b-left": !_vm.stateUserIsReduxMode
                                    }
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium white" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantySticky.damageSummary.tableMain.totalCost"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "tab-separator" }),
                              _c("div", { staticClass: "tab-ren table-cell" }, [
                                !_vm.stateUserIsReduxMode
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium white" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "warrantySticky.damageSummary.tableMain.priceWithoutTaxes"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "b-left": !_vm.stateUserIsReduxMode
                                    }
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "text-medium white" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "warrantySticky.damageSummary.tableMain.priceWithTaxes"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "tab-separator" }),
                              _c(
                                "div",
                                { staticClass: "tab-asp table-cell b-right" },
                                [
                                  !_vm.stateUserIsReduxMode
                                    ? _c("div", [
                                        _c(
                                          "p",
                                          { staticClass: "text-medium white" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "warrantySticky.damageSummary.tableMain.priceWithoutTaxes"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      class: {
                                        "b-left": !_vm.stateUserIsReduxMode
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-medium white" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "warrantySticky.damageSummary.tableMain.priceWithTaxes"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "tab-container" },
                            _vm._l(damages.professions, function(profession) {
                              return _c(
                                "div",
                                { staticClass: "tab-group-list" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "tab-damages-list d-flex" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tab-damages b-left" },
                                        [
                                          profession.name
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-medium black",
                                                  class: {
                                                    "damage-name-mix":
                                                      _vm.isMixAvailable
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(profession.name)
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-medium black",
                                                  class: {
                                                    "damage-name-mix":
                                                      _vm.isMixAvailable
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(profession.damage)
                                                  )
                                                ]
                                              )
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass: "tab-separator"
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "tab-gag table-cell" },
                                        [
                                          !_vm.stateUserIsReduxMode
                                            ? _c("div", [
                                                _c("p", {
                                                  staticClass:
                                                    "text-medium black"
                                                })
                                              ])
                                            : _vm._e(),
                                          !_vm.stateUserIsReduxMode
                                            ? _c(
                                                "div",
                                                { staticClass: "b-left" },
                                                [
                                                  _c("p", {
                                                    staticClass:
                                                      "text-medium black"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          !_vm.stateUserIsReduxMode
                                            ? _c(
                                                "div",
                                                { staticClass: "b-left" },
                                                [
                                                  _c("p", {
                                                    staticClass:
                                                      "text-medium black"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "total-value",
                                              class: {
                                                "b-left": !_vm.stateUserIsReduxMode
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "cellContent" },
                                                [
                                                  _c("p", {
                                                    staticClass:
                                                      "text-medium black"
                                                  })
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass: "tab-separator"
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "tab-ren table-cell" },
                                        [
                                          !_vm.stateUserIsReduxMode
                                            ? _c("div", [
                                                _c("p", {
                                                  staticClass:
                                                    "text-medium black"
                                                })
                                              ])
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "total-value",
                                              class: {
                                                "b-left": !_vm.stateUserIsReduxMode
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "cellContent" },
                                                [
                                                  _c("p", {
                                                    staticClass:
                                                      "text-medium black"
                                                  })
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass: "tab-separator"
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tab-asp table-cell b-right"
                                        },
                                        [
                                          !_vm.stateUserIsReduxMode
                                            ? _c("div", [
                                                _c("p", {
                                                  staticClass:
                                                    "text-medium black"
                                                })
                                              ])
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "total-value",
                                              class: {
                                                "b-left": !_vm.stateUserIsReduxMode
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "cellContent" },
                                                [
                                                  _c("p", {
                                                    staticClass:
                                                      "text-medium black"
                                                  })
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._l(profession.damages, function(damage) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "tab-group-list tab-list-description"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tab-damages bg-white b-left"
                                          },
                                          [
                                            damage.damage.description
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-medium black",
                                                    class: {
                                                      "damage-name-mix":
                                                        _vm.isMixAvailable
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        damage.damage
                                                          .description
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-medium black",
                                                    class: {
                                                      "damage-name-mix":
                                                        _vm.isMixAvailable
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(damage.damage)
                                                    )
                                                  ]
                                                ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "damage-name-actions"
                                              },
                                              [
                                                damage.images &&
                                                _vm.isMixAvailable
                                                  ? _c(
                                                      "span",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.preparePhotosModal(
                                                              damage
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        damage.images.length > 0
                                                          ? _c("svgicon", {
                                                              attrs: {
                                                                icon:
                                                                  "ico-photos",
                                                                height: "16",
                                                                color: "#A7AEB6"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                damage.can_delete &&
                                                _vm.isMixAvailable
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "right",
                                                        attrs: {
                                                          "qa-deleteReportItem-button":
                                                            ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleRemoveDamage(
                                                              damage.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("svgicon", {
                                                          staticClass:
                                                            "svg-icon svg-icon-action",
                                                          attrs: {
                                                            icon: "trash",
                                                            height: "18"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass: "tab-separator"
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tab-gag bg-white table-cell"
                                          },
                                          [
                                            !_vm.stateUserIsReduxMode
                                              ? _c("div", [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-medium black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          damage.gag
                                                            .manpower_hours
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            !_vm.stateUserIsReduxMode
                                              ? _c(
                                                  "div",
                                                  { staticClass: "b-left" },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-medium black"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            damage.gag
                                                              .manpower_cost
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            !_vm.stateUserIsReduxMode
                                              ? _c(
                                                  "div",
                                                  { staticClass: "b-left" },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-medium black"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            damage.gag
                                                              .material_cost
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "total-value",
                                                class: {
                                                  "b-left": !_vm.stateUserIsReduxMode
                                                }
                                              },
                                              [
                                                _c(
                                                  "ma-mix-clickable-cell",
                                                  {
                                                    attrs: {
                                                      damageId: damage.id,
                                                      isMixEnabled: !!(
                                                        _vm.isMixAvailable &&
                                                        damage.id
                                                      ),
                                                      type: _vm.gagKey,
                                                      repTypeSelected:
                                                        damage.rep_type,
                                                      selected:
                                                        damage.rep_type ===
                                                        _vm.gagKey
                                                    },
                                                    on: {
                                                      selected: function(
                                                        $event
                                                      ) {
                                                        return _vm.handleOnSelectTotal(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "cellContent" },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-medium black"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                damage.gag
                                                                  .gag_cost
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass: "tab-separator"
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tab-ren bg-white table-cell"
                                          },
                                          [
                                            !_vm.stateUserIsReduxMode
                                              ? _c("div", [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-medium black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          damage
                                                            .authorized_network_repair
                                                            .market_price_without_taxes
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "total-value",
                                                class: {
                                                  "b-left": !_vm.stateUserIsReduxMode
                                                }
                                              },
                                              [
                                                _c(
                                                  "ma-mix-clickable-cell",
                                                  {
                                                    attrs: {
                                                      damageId: damage.id,
                                                      isMixEnabled: !!(
                                                        _vm.isMixAvailable &&
                                                        damage.id
                                                      ),
                                                      type:
                                                        _vm.networkRepairKey,
                                                      repTypeSelected:
                                                        damage.rep_type,
                                                      selected:
                                                        damage.rep_type ===
                                                        _vm.networkRepairKey
                                                    },
                                                    on: {
                                                      selected: function(
                                                        $event
                                                      ) {
                                                        return _vm.handleOnSelectTotal(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "cellContent" },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-medium black"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                damage
                                                                  .authorized_network_repair
                                                                  .market_price_with_taxes
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass: "tab-separator"
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tab-asp bg-white table-cell b-right"
                                          },
                                          [
                                            !_vm.stateUserIsReduxMode
                                              ? _c("div", [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-medium black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          damage
                                                            .artessian_repair
                                                            .market_price_without_taxes
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "total-value",
                                                class: {
                                                  "b-left": !_vm.stateUserIsReduxMode
                                                }
                                              },
                                              [
                                                _c(
                                                  "ma-mix-clickable-cell",
                                                  {
                                                    attrs: {
                                                      damageId: damage.id,
                                                      isMixEnabled: !!(
                                                        _vm.isMixAvailable &&
                                                        damage.id
                                                      ),
                                                      type:
                                                        _vm.artessianRepairKey,
                                                      repTypeSelected:
                                                        damage.rep_type,
                                                      selected:
                                                        damage.rep_type ===
                                                        _vm.artessianRepairKey
                                                    },
                                                    on: {
                                                      selected: function(
                                                        $event
                                                      ) {
                                                        return _vm.handleOnSelectTotal(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "cellContent" },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-medium black"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                damage
                                                                  .artessian_repair
                                                                  .market_price_with_taxes
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        !_vm.isMixAvailable
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "delete-damage"
                                                              },
                                                              [
                                                                damage.can_delete &&
                                                                !_vm.isMixAvailable
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "left",
                                                                        attrs: {
                                                                          "qa-deleteReportItem-button":
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.handleRemoveDamage(
                                                                              damage.id
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "svgicon",
                                                                          {
                                                                            staticClass:
                                                                              "svg-icon svg-icon-action",
                                                                            attrs: {
                                                                              icon:
                                                                                "trash",
                                                                              height:
                                                                                "18"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "tab-container tab-group-totals d-flex"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tab-damages b-left" },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.$t("common.total"))
                                            )
                                          ])
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass: "tab-separator"
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "tab-gag table-cell" },
                                        [
                                          !_vm.stateUserIsReduxMode
                                            ? _c("div", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-medium black"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("floatToFixed")(
                                                          profession.totals
                                                            .manpower_hours,
                                                          1
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          !_vm.stateUserIsReduxMode
                                            ? _c(
                                                "div",
                                                { staticClass: "b-left" },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-medium black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "floatToFixed"
                                                          )(
                                                            profession.totals
                                                              .total_manpower_cost,
                                                            1
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          !_vm.stateUserIsReduxMode
                                            ? _c(
                                                "div",
                                                { staticClass: "b-left" },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-medium black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "floatToFixed"
                                                          )(
                                                            profession.totals
                                                              .total_material_cost,
                                                            1
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                "b-left": !_vm.stateUserIsReduxMode
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-medium black"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("floatToFixed")(
                                                        profession.totals
                                                          .total_gag_cost,
                                                        1
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass: "tab-separator"
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "tab-ren table-cell" },
                                        [
                                          !_vm.stateUserIsReduxMode
                                            ? _c("div", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-medium black"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("floatToFixed")(
                                                          profession.totals
                                                            .authorized_network_repair_without_taxes,
                                                          1
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                "b-left": !_vm.stateUserIsReduxMode
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-medium black"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("floatToFixed")(
                                                        profession.totals
                                                          .authorized_network_repair,
                                                        1
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass: "tab-separator"
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tab-asp table-cell b-right"
                                        },
                                        [
                                          !_vm.stateUserIsReduxMode
                                            ? _c("div", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-medium black"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("floatToFixed")(
                                                          profession.totals
                                                            .artessian_repair_without_taxes,
                                                          1
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                "b-left": !_vm.stateUserIsReduxMode
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-medium black"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("floatToFixed")(
                                                        profession.totals
                                                          .artessian_repair,
                                                        1
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            }),
                            0
                          )
                        ])
                      })
                    : _vm._e()
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm.stateWarrantyReport && _vm.warrantiesList
        ? _c("div", { staticClass: "table-section" }, [
            _c(
              "div",
              {
                staticClass: "table-content table-totals-values",
                class: { "redux-mode": _vm.stateUserIsReduxMode }
              },
              [
                _c("div", { staticClass: "tab-group-header d-flex" }, [
                  _c("div", { staticClass: "tab-damages border-none" }),
                  _c("div", { staticClass: "tab-separator" }),
                  _c("div", { staticClass: "tab-gag border-none" }, [
                    _c(
                      "div",
                      {
                        staticClass: "list list--counter",
                        class: [
                          _vm.getCostBackgroundColor(
                            _vm.totals.authorized_network_repair_without_taxes
                          ),
                          _vm.isRepairTypeChecked("GAG"),
                          { "input-mix-composition": _vm.isMixAvailable }
                        ],
                        attrs: { id: "greAGreTotal" },
                        on: {
                          click: function($event) {
                            return _vm.handleChangeRepairType("GAG", "REGULAR")
                          }
                        }
                      },
                      [
                        !_vm.isMixAvailable
                          ? _c("div", { staticClass: "option" }, [
                              _c("input", {
                                attrs: {
                                  type: "radio",
                                  name: "repairType",
                                  id: "GAG"
                                },
                                domProps: { checked: _vm.gagInput }
                              }),
                              _c("label", { attrs: { for: "GAG" } })
                            ])
                          : _vm._e(),
                        _c("ul", { staticClass: "elementRepair" }, [
                          _c("li", [
                            !_vm.isMixAvailable && _vm.stateUserIsReduxMode
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.global_totals.gag,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                )
                              : !_vm.isMixAvailable && !_vm.stateUserIsReduxMode
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.totals.gag,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.global_totals.gag_mix,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                ),
                            _c("p", { staticClass: "text-small white" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("warrantySticky.damageCounters.gag")
                                )
                              )
                            ])
                          ]),
                          !_vm.stateUserIsReduxMode
                            ? _c("li", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.totals.materials,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                ),
                                _c("p", { staticClass: "text-small white" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "warrantySticky.damageCounters.materials"
                                        )
                                      )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          !_vm.stateUserIsReduxMode
                            ? _c("li", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.totals.estimated_time,
                                          1
                                        )
                                      ) + " h"
                                    )
                                  ]
                                ),
                                _c("p", { staticClass: "text-small white" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "warrantySticky.damageCounters.estimatedTime"
                                        )
                                      )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "tab-separator" }),
                  _c("div", { staticClass: "tab-ren border-none" }, [
                    _c(
                      "div",
                      {
                        staticClass: "list list--counter",
                        class: [
                          _vm.getCostBackgroundColor(
                            _vm.totals.authorized_network_repair_without_taxes
                          ),
                          _vm.isRepairTypeChecked("REN"),
                          { "input-mix-composition": _vm.isMixAvailable }
                        ],
                        attrs: { id: "reparationNetworkTotal" },
                        on: {
                          click: function($event) {
                            return _vm.handleChangeRepairType("REN", "REGULAR")
                          }
                        }
                      },
                      [
                        !_vm.isMixAvailable
                          ? _c("div", { staticClass: "option" }, [
                              _c("input", {
                                attrs: {
                                  type: "radio",
                                  name: "repairType",
                                  id: "REN"
                                },
                                domProps: { checked: _vm.renInput }
                              }),
                              _c("label", { attrs: { for: "REN" } })
                            ])
                          : _vm._e(),
                        _c("ul", { staticClass: "elementRepair" }, [
                          _c("li", [
                            !_vm.isMixAvailable && _vm.stateUserIsReduxMode
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.global_totals
                                            .authorized_network_repair,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                )
                              : !_vm.isMixAvailable && !_vm.stateUserIsReduxMode
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.totals.authorized_network_repair,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.global_totals
                                            .authorized_network_repair_mix,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                ),
                            _c("p", { staticClass: "text-small white" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "warrantySticky.damageCounters.authorizedNetworkRepair"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "tab-separator" }),
                  _c("div", { staticClass: "tab-asp border-none" }, [
                    _c(
                      "div",
                      {
                        staticClass: "list list--counter",
                        class: [
                          _vm.getCostBackgroundColor(
                            _vm.totals.artessian_repair_without_taxes
                          ),
                          _vm.isRepairTypeChecked("ASP"),
                          { "input-mix-composition": _vm.isMixAvailable }
                        ],
                        attrs: { id: "reparationExceptTotal" },
                        on: {
                          click: function($event) {
                            return _vm.handleChangeRepairType("ASP", "REGULAR")
                          }
                        }
                      },
                      [
                        !_vm.isMixAvailable
                          ? _c("div", { staticClass: "option" }, [
                              _c("input", {
                                attrs: {
                                  type: "radio",
                                  name: "repairType",
                                  id: "ASP"
                                },
                                domProps: { checked: _vm.aspInput }
                              }),
                              _c("label", { attrs: { for: "ASP" } })
                            ])
                          : _vm._e(),
                        _c("ul", { staticClass: "elementRepair" }, [
                          _c("li", [
                            !_vm.isMixAvailable && _vm.stateUserIsReduxMode
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.global_totals.artessian_repair,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                )
                              : !_vm.isMixAvailable && !_vm.stateUserIsReduxMode
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.totals.artessian_repair,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.global_totals
                                            .artessian_repair_mix,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                ),
                            _c("p", { staticClass: "text-small white" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "warrantySticky.damageCounters.artessianRepair"
                                  )
                                )
                              )
                            ])
                          ]),
                          !_vm.stateUserIsReduxMode
                            ? _c("li", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.totals.immediate,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                ),
                                _c("p", { staticClass: "text-small white" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "warrantySticky.damageCounters.immediate"
                                        )
                                      )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          !_vm.stateUserIsReduxMode
                            ? _c("li", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium white mg mg--b-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("floatToFixed")(
                                          _vm.totals.difference,
                                          1
                                        )
                                      ) + " €"
                                    )
                                  ]
                                ),
                                _c("p", { staticClass: "text-small white" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "warrantySticky.damageCounters.difference"
                                        )
                                      )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "tab-group-header d-flex border-none" },
                  [
                    _c("div", { staticClass: "tab-damages border-none" }),
                    _c("div", { staticClass: "tab-separator border-none" }),
                    _c("div", { staticClass: "tab-total-mix border-none" }, [
                      _vm.isMixAvailable
                        ? _c(
                            "div",
                            { staticClass: "mg mg--t-3 total-mix-composition" },
                            [
                              !_vm.isMixAvailable
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "headline-medium white mg mg--b-1"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("floatToFixed")(
                                            _vm.totalAmount,
                                            1
                                          )
                                        ) + " €"
                                      )
                                    ]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "headline-medium white mg mg--b-1"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("floatToFixed")(
                                            _vm.globalTotalAmount,
                                            1
                                          )
                                        ) + " €"
                                      )
                                    ]
                                  ),
                              _c("p", { staticClass: "text-small white" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "warrantySticky.damageCounters.totalPrice"
                                      )
                                    )
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _c(
        "ma-modal",
        {
          ref: "photosModal",
          staticClass: "modal--photos",
          attrs: { type: "large" }
        },
        [
          _c(
            "template",
            { slot: "modalContent" },
            [
              _vm.damagePhotos.damageName
                ? _c("p", { staticClass: "headline-large mg mg--b-5 black" }, [
                    _vm._v(_vm._s(_vm.damagePhotos.damageName.description))
                  ])
                : _vm._e(),
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [
                  _vm.damagePhotos.showTabSelector
                    ? _c("ma-tab-selector", {
                        attrs: {
                          options: _vm.damagePhotos.tabs,
                          selectedOption: _vm.damagePhotos.activeTab
                        },
                        on: {
                          click: function(value) {
                            return _vm.handleTabClick(value)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "photos-container" }, [
                _c(
                  "div",
                  { staticClass: "zoom-buttons" },
                  [
                    _c("svgicon", {
                      staticClass: "svg-icon-action",
                      class: { disabled: this.scale >= this.maxScale },
                      attrs: { name: "zoom-in" },
                      on: {
                        click: function($event) {
                          return _vm.handleZoomIn()
                        }
                      }
                    }),
                    _c("svgicon", {
                      staticClass: "svg-icon-action",
                      class: { disabled: this.scale <= this.minScale },
                      attrs: { name: "zoom-out" },
                      on: {
                        click: function($event) {
                          return _vm.handleZoomOut()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "canvas-wrapper" }, [
                  _c("canvas", { ref: "canvas", staticClass: "main-photo" })
                ]),
                _c(
                  "div",
                  { staticClass: "photos-array" },
                  _vm._l(_vm.damagePhotos[_vm.damagePhotos.activeTab], function(
                    photo,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        staticClass: "thumbnail",
                        class: {
                          selected: index === _vm.damagePhotos.activePhotoIndex
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleThumbnailClick(index)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: photo.imageURL,
                            width: "60",
                            height: "60"
                          }
                        })
                      ]
                    )
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        2
      ),
      _c(
        "ma-modal",
        {
          ref: "manpowerModal",
          staticClass: "modal--manpower",
          attrs: { type: "small" }
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main" },
              [
                _c("p", { staticClass: "headline-large mg mg--b-5 black" }, [
                  _vm._v(_vm._s(_vm.$t("warrantySticky.manPower.title")))
                ]),
                _c(
                  "transition",
                  { attrs: { name: "fade", mode: "out-in" } },
                  [
                    _c("maRange", {
                      attrs: {
                        min: _vm.range.min_price,
                        max: _vm.range.max_price,
                        standard: _vm.range.standard_price,
                        recommended: _vm.range.recommended_price_hour,
                        initial: _vm.price,
                        gap: "5",
                        title: _vm.$t("range.title")
                      },
                      on: {
                        change: function(v) {
                          return (_vm.price = v)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleSetPriceButtonClick }
                },
                [_vm._v(_vm._s(_vm.$t("warrantySticky.manPower.setPrice")))]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }